import { Game } from "./Game";

(new Game).run();

